import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ZyConsoleNodeView from './zyconsole-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyConsole: {
            insertZyConsole: () => ReturnType;
        };
    }
}

export const ZyConsoleHeadless = Node.create({
    name: 'zyConsole',

    content: 'text*',

    group: 'block',

    draggable: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id') || '';
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
            'preserve-white-space': {
                default: false,
                parseHTML: element => {
                    return element.getAttribute('preserve-white-space') === 'true';
                },
                renderHTML: attributes => {
                    if (!attributes['preserve-white-space']) {
                        return {};
                    }
                    return {
                        'preserve-white-space': 'true',
                    };
                },
            },
            highlight: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('highlight') || null;
                },
                renderHTML: attributes => {
                    if (!attributes.highlight) {
                        return {};
                    }
                    return {
                        highlight: attributes.highlight,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyConsole',
                preserveWhitespace: 'full',
                getAttrs: element => {
                    if (!(element instanceof HTMLElement)) {
                        return false;
                    }
                    return {
                        id: element.getAttribute('id'),
                        'preserve-white-space': element.getAttribute('preserve-white-space') === 'true',
                        highlight: element.getAttribute('highlight') || null,
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyConsole', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyConsole:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            'preserve-white-space': false,
                            highlight: null,
                        },
                    });
                },
        };
    },
});

export const ZyConsole = ZyConsoleHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyConsoleNodeView);
    },
});

export default ZyConsole;
